import { Skeleton, Typography, Box } from '@cast/design-system';

type AutonomousActionsCountProps = {
  totalCount: number;
  isLoading: boolean;
};

export const AutonomousActionsCount = ({
  totalCount,
  isLoading,
}: AutonomousActionsCountProps) => (
  <Box
    data-testid="autonomous-actions-count"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      p: 24,
      flexShrink: 0,
    }}
  >
    {isLoading ? (
      <Skeleton variant="text" width="100%" height={52} />
    ) : (
      <Typography variant="h1">{totalCount}</Typography>
    )}
    <Typography variant="P12R" color="textSecondary">
      Autonomous actions
    </Typography>
  </Box>
);
